import * as React from "react";
import { FirebaseDocument } from "common/models/FirebaseDocument";
import i18n from "i18n";
import { Link } from "react-router-dom";
import {
  GridListTile,
  GridListTileBar,
  Typography,
  Snackbar,
  Input,
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
} from "@material-ui/core";
import {
  StarBorder as StarIcon,
  Star as StarChecked,
  Image,
  Group,
  Person,
  MoreVert,
  Close,
} from "@material-ui/icons";
import { Development } from "modules/development/models/Development";
import { DevelopmentService } from "modules/development/DevelopmentService";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { ExceptionStore } from "common/exception/ExceptionStore";
import { LoginStore } from "modules/login/LoginStore";
import { LoginService } from "modules/login/LoginService";
import { User } from "modules/login/models/User";
import { ProfileService } from "modules/profile/ProfileService";
import DevelopmentAvatar from "modules/development/components/layouts/DevelopmentAvatar";
import { StyleSheet, css } from "aphrodite";
import CardGridImage from "./CardGridImage";
import { Redirect } from "react-router-dom";

const styles = StyleSheet.create({
  gridList: {
    backgroundColor: "#ffffff",
    margin: 12.5,
    ":hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
    ":hover > div > #layer": {
      opacity: 1,
    },
    ":hover > div > :last-child > :last-child > div > svg": {
      opacity: 1,
    },
    transition: "box-shadow 300ms ease-in",
  },
  gridListOpenMenu: {
    backgroundColor: "#ffffff",
    margin: 12.5,
    boxShadow:
      "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
  },
  cardMenu: {
    fontSize: 14,
    "& ul": {
      padding: 0,
    },
    "& li": {
      fontSize: 14,
    },
  },
  tile: {
    width: "100%",
    height: "65px",
    backgroundColor: "#ffffff",
    "& > div:first-child": {
      marginRight: 55,
    },
  },
  tileTitle: {
    paddingBottom: "5px",
    marginTop: "5px",
  },
  tileTitleSpan: {
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000000",
    fontSize: "14px",
    cursor: "pointer",
    display: "inline-block",
    marginTop: "5px",
    minWidth: "40px",
    ":hover": {
      borderBottom: "1px dotted",
    },
  },
  inputName: {
    fontFamily: "Roboto",
    fontWeight: 500,
    color: "#000000",
    fontSize: "14px",
    padding: "0px",
    "::selection": {
      background: "#ABC200",
    },
    "::after": {
      borderBottom: "1px solid !important",
    },
  },
  tileSubtitle: {
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#7f7f7f",
    fontSize: "11px",
    paddingBottom: "5px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  starIcon: {
    color: "#ababab",
    marginRight: "15px",
    transition: "all 300ms ease-in",
    position: "relative" as any,
    ":hover": {
      color: "#ABC200",
    },
  },
  starIconChecked: {
    transition: "all 300ms ease-in",
    color: "#ABC200",
    marginRight: "15px",
    position: "relative" as any,
  },
  subtitle: {
    fontFamily: "Roboto",
    fontWeight: 400,
    color: "#7f7f7f",
    fontSize: "11px",
    paddingBottom: "5px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  disabled: {
    color: "white",
    pointerEvents: "none" as any,
  },
  disabledChecked: {
    color: "#ababab",
    pointerEvents: "none" as any,
  },
  deleteIcon: {
    top: -56,
    right: 8,
    color: "#919191",
    zIndex: 2,
  },
  imageIcon: {
    top: 15,
    left: 10,
    color: "#919191",
    zIndex: 2,
    transition: "color 200ms ease-in",
    ":hover": {
      color: "#ffffff",
    },
  },
  layerOptions: {
    top: 0,
    left: 0,
    width: "100%",
    height: "125px",
    backgroundColor: "rgba(0,0,0,0.7)",
    zIndex: 1,
    cursor: "pointer",
    transition: "opacity 300ms ease-in",
    textDecoration: "none",
    marginTop: 65,
  },
  viewProject: {
    border: "1px solid",
    borderColor: "#919191",
    padding: "5px 10px",
    color: "#919191",
    width: "fit-content",
    margin: "0 auto",
    marginTop: "60px",
    height: "24px",
    borderRadius: "12px",
    fontSize: "11px",
    fontFamily: "Raleway",
    fontWeight: 700,
    transition: "all 200ms ease-in",
    ":hover": {
      borderColor: "#ffffff",
      color: "#ffffff",
    },
    lineHeight: "120%",
    letterSpacing: "2px",
  },
});

type IProps = {
  key: string;
  development: FirebaseDocument<Development>;
  selected: Boolean;
};

class CardGrid extends React.Component<IProps> {
  state = {
    open: false,
    editName: false,
    newName: "",
    disabledInput: false,
    inputName: null as any,
    userList: [],
    displayName: "",
    owner: [],
    anchorEl: null,
  };

  componentDidMount() {
    let dev = this.props.development;
    DevelopmentStore.currentUser = undefined
      ? DevelopmentService.getUsersList(dev).then((nameUser) => {
          this.setState({ userList: nameUser });
        })
      : DevelopmentStore.currentUser;

    this.getOwnerName();
  }

  componentWillReceiveProps() {
    let dev = this.props.development;
    this.userList(dev);
    this.getOwnerName();
  }

  componentDidCatch(error, info) {
    ExceptionStore.OpenException(info);
  }

  handleNameChange = (e) => {
    this.state.newName = e.target.value;
  };
  handleClickName = () =>
    this.setState(
      { newName: this.props.development.data.name, editName: true },
      () => {
        this.state.inputName.focus();
        this.state.inputName.select();
      }
    );

  saveNewName = async () => {
    if (
      this.state.newName != "" &&
      this.state.newName !== this.props.development.data.name
    ) {
      await DevelopmentService.changeDevelopmentName(
        this.props.development,
        this.state.newName
      );
    }
    this.setState({ disabledInput: false, editName: false });
  };

  handleRemoveAcces = (dev) => (e) => {
    DevelopmentStore.removAccessDevelopment = dev;
    this.killEvent(e);
  };

  handleDelete = (dev) => (e) => {
    DevelopmentStore.deleteDevelopment = dev;
    this.killEvent(e);
  };

  handleOpenSelection = (dev) => (e) => {
    DevelopmentStore.updateImageDevelopment = dev;
    DevelopmentStore.buttonFileUpload.dispatchEvent(new MouseEvent("click"));
    this.killEvent(e);
  };

  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  handleSetFavorite = (id) => async () => {
    this.setState({ [`disabled_${id}`]: true });
    await DevelopmentStore.setFavorite(id);
    this.setState({ [`disabled_${id}`]: false });
  };

  handleUnsetFavorite = (id) => async () => {
    this.setState({ [`disabled_${id}`]: true });
    await DevelopmentStore.unsetFavorite(id);
    this.setState({ [`disabled_${id}`]: false });
  };

  getTimeDiffByMonth = (months, date1, date2) => {
    let days = date1.getDate() - date2.getDate();
    if (months > 0 && days <= 0) {
      months -= 1;
      days += new Date(date2.getFullYear(), date2.getMonth() + 1, 0).getDate();
    }
    if (months === 0) {
      if (days >= 7) {
        let weeks = Math.trunc(days / 7);
        return `${
          weeks === 1 ? `1 ${i18n.date.week}` : `${weeks} ${i18n.date.weeks}`
        } ${i18n.date.ago}`;
      } else if (days !== 0)
        return `${
          days === 1 ? `1 ${i18n.date.day}` : `${days} ${i18n.date.days}`
        } ${i18n.date.ago}`;
      else return i18n.date.today;
    } else
      return `${
        months === 1 ? `1 ${i18n.date.month}` : `${months} ${i18n.date.months}`
      } ${i18n.date.ago}`;
  };
  getTimeDiff = (date1: Date, date2: Date) => {
    let years = date1.getFullYear() - date2.getFullYear();
    let months = date1.getMonth() - date2.getMonth();
    if (years > 0 && months <= 0) {
      years -= 1;
      months += 12;
    }
    if (years === 0) return this.getTimeDiffByMonth(months, date1, date2);
    else {
      let days = date1.getDate() - date2.getDate();
      if (months > 0 && days <= 0) months -= 1;
      return (
        (years === 1 ? `1 ${i18n.date.year}` : `${years} ${i18n.date.years}`) +
        (months > 0
          ? months === 1
            ? ` e 1 ${i18n.date.month}`
            : ` e ${months} ${i18n.date.months}`
          : "") +
        ` ${i18n.date.ago}`
      );
    }
  };

  handleOpenShareDevelopment = (dev) => async (e) => {
    let uid: any = dev.data.users;
    let users: Array<User | undefined> = [];

    for (let userId in uid) {
      users.push(await LoginStore.getUser(userId));
    }
    DevelopmentStore.shareUsers = users;
    DevelopmentStore.openShareDevelopment = dev;
    DevelopmentStore.openShareDevelopmentDialog = Boolean(dev.id);

    this.killEvent(e);
  };

  userList(dev) {
    if (dev.data.users[ProfileService.getUserId()] == 0) {
      if (dev.data.sharedUsers && dev.data.sharedUsers.length > 0) {
        return dev.data.sharedUsers
          .map(function (u) {
            return u.displayName;
          })
          .join(", ");
      } else {
        return i18n.developments.shareDevelopment;
      }
    } else {
      return i18n.developments.developmentSharedWithMe;
    }
  }

  getOwnerName = async () => {
    let {
        props: { development },
        state: { displayName },
      } = this,
      name = development.data.ownerName,
      users = development.data.users,
      uid = Object.keys(users).find((key) => users[key] === 0),
      newDisplayName;
    if (name != undefined) {
      this.setState({
        displayName: name,
      });
    } else {
      if (uid) {
        if (LoginStore.userAuth && uid === LoginStore.userAuth.uid)
          newDisplayName = LoginStore.userAuth.displayName;
        else newDisplayName = await LoginService.getUserName(uid);
        if (newDisplayName !== displayName)
          this.setState({ displayName: newDisplayName });
      } else if (displayName !== "") this.setState({ displayName: "" });
    }
  };

  renderOwnerName = () => (
    <div>
      {i18n.rateLibraries.cardProcessing.by + " " + this.state.displayName}
      <Person
        style={{
          fontSize: 14,
          position: "relative",
          top: 3,
          left: 3,
          color: "#BABABA",
        }}
      />
    </div>
  );

  handleClickOptCard = (event) => {
    this.setState({ anchorEl: event.currentTarget });
    this.killEvent(event);
  };

  handleCloseOptCard = (event) => {
    this.killEvent(event);
    this.setState({ anchorEl: null });
  };

  handleOpenLayerAdd = (event) => {
    DevelopmentStore.firstLoad = true;
    DevelopmentStore.isEditAddress = false;
    DevelopmentStore.setDevelopmentCopied(this.props.development);
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  handleCloseSnack = () => {
    this.setState({ open: false });
  };

  handleEditAddress = (event, dev) => {
    DevelopmentStore.firstLoad = true;
    DevelopmentStore.isEditAddress = dev;
    DevelopmentStore.layerAdd = true;
    this.setState({ anchorEl: null });
    this.killEvent(event);
  };

  handleConvert = async (event) => {
    let dev = this.props.development;
    if (dev.data.refactoring) {
      this.state.open = true;
    } else if (!dev.data.version || dev.data.version !== 2) {
      let refactorResult = await DevelopmentStore.refactorProjectAndOpen(dev);
      if (!refactorResult) {
        this.setState({ open: true });
      } else {
        DevelopmentStore.refactorComplete = dev.id;
      }
    }
  };

  renderRedirect = () => {
    if (DevelopmentStore.refactorComplete === this.props.development.id) {
      let path = `/${this.props.development.id}/WBS`;
      DevelopmentStore.updateResources = true;
      return <Redirect to={path} />;
    } else return false;
  };

  render() {
    const { id } = this.props.development,
      { editName, disabledInput, userList } = this.state;
    const open = Boolean(this.state.anchorEl);
    let dev = this.props.development;
    var arraySplit: any = [];
    if (dev.data.address) {
      arraySplit = dev.data.address.split(",", 2);
    }
    //to-do: corrigir as datas nofirebase e alterar o codigo abaixo.
    let subtitle = dev.data.modifyAt
      ? this.getTimeDiff(new Date(), new Date(dev.data.modifyAt.seconds * 1000))
      : "";

    const isExpired = LoginStore.expiredTrial();

    return (
      <React.Fragment>
        {this.renderRedirect()}
        <GridListTile
          key={dev.id}
          className={open ? css(styles.gridListOpenMenu) : css(styles.gridList)}
          style={{ position: "relative", width: "295px", height: "295px" }}
        >
          <GridListTileBar
            className={css(styles.tile)}
            classes={{
              subtitle: css(styles.tileSubtitle),
            }}
            style={{ position: "relative" }}
            title={
              editName ? (
                <label
                  ref={(node: any) =>
                    (this.state.inputName =
                      node && node.childNodes[0]
                        ? node.childNodes[0].childNodes[0]
                        : null)
                  }
                >
                  <Input
                    inputProps={{
                      maxLength: "30",
                    }}
                    classes={{ input: css(styles.inputName) }}
                    defaultValue={this.state.newName}
                    placeholder={i18n.developments.name}
                    onChange={this.handleNameChange}
                    onBlur={this.saveNewName}
                    disabled={disabledInput}
                  />
                </label>
              ) : (
                <Typography
                  className={css(styles.tileTitleSpan)}
                  component="span"
                  onClick={isExpired ? () => false : this.handleClickName}
                >
                  {dev.data.name}
                </Typography>
              )
            }
            subtitle={this.renderOwnerName()}
            actionIcon={<DevelopmentAvatar development={dev} />}
            titlePosition="top"
            actionPosition="left"
          />
          <Link
            id="layer"
            to={
              isExpired
                ? "#"
                : dev.data.refactoring ||
                  !dev.data.version ||
                  dev.data.version !== 2
                ? "#"
                : `/${id}/WBS`
            }
            className={css(styles.layerOptions)}
            onClick={this.handleConvert}
            style={{ position: "absolute", opacity: open ? 1 : 0 }}
          >
            <Image
              style={{ position: "absolute", marginTop: "65px !important" }}
              fontSize="small"
              className={css(styles.imageIcon)}
              onClick={isExpired ? () => false : this.handleOpenSelection(dev)}
            />
            <IconButton
              aria-label="More"
              aria-owns={open ? "long-menu" : undefined}
              aria-haspopup="true"
              onClick={isExpired ? () => false : this.handleClickOptCard}
              style={{ position: "absolute", display: "inline" }}
              className={css(styles.deleteIcon)}
            >
              <MoreVert />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={this.state.anchorEl}
              open={open}
              onClose={this.handleCloseOptCard}
              getContentAnchorEl={null}
              disableAutoFocusItem
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
              PaperProps={{
                style: {
                  width: 160,
                },
              }}
              className={css(styles.cardMenu)}
            >
              <MenuItem
                key={0}
                selected={false}
                style={{ fontSize: 12 }}
                onClick={this.handleOpenLayerAdd}
              >
                Criar novo a partir desse
              </MenuItem>
              <MenuItem
                key={1}
                selected={false}
                style={{ fontSize: 12 }}
                onClick={(e) => this.handleEditAddress(e, dev)}
              >
                Editar endereço
              </MenuItem>
              {dev.data.users[ProfileService.getUserId()] == 1 ? (
                <MenuItem
                  key={2}
                  selected={false}
                  onClick={this.handleRemoveAcces(dev)}
                  style={{ fontSize: 12 }}
                >
                  {i18n.developments.removeAccess}
                </MenuItem>
              ) : (
                <></>
              )}
              {dev.data.users[ProfileService.getUserId()] == 0 ? (
                <MenuItem
                  key={2}
                  selected={false}
                  onClick={this.handleDelete(dev)}
                  style={{ fontSize: 12 }}
                >
                  {i18n.delete}
                </MenuItem>
              ) : (
                <></>
              )}
            </Menu>

            <Typography className={css(styles.viewProject)} component="span">
              {i18n.developments.view}
            </Typography>
          </Link>
          <CardGridImage
            imageUrl={(dev.data as any).image}
            imageName={(dev.data as any).imageName}
          />
          <GridListTileBar
            className={css(styles.tile)}
            classes={{
              title: css(styles.tileTitle),
              subtitle: css(styles.tileSubtitle),
            }}
            title={""}
            subtitle={
              <Typography
                className={css(styles.subtitle)}
                style={{
                  position: "absolute",
                  width: "90%",
                  marginTop: "-55px",
                }}
                component="span"
              >
                {dev.data.address != "" && (
                  <Tooltip title={dev.data.address}>
                    <div
                      style={{
                        color: "black",
                        marginBottom: "10px",
                        overflow: "hidden",
                        whiteSpace: "nowrap" as any,
                        textOverflow: "ellipsis",
                      }}
                    >
                      {arraySplit[0] ? arraySplit[0] : ""}
                      {arraySplit[1] ? ", " + arraySplit[1] : ""}
                    </div>
                  </Tooltip>
                )}
                {subtitle}
                <br />
                {dev.data.users[ProfileService.getUserId()] == 0 ? (
                  <Tooltip
                    title={
                      userList.length == 0
                        ? i18n.developments.shareDevelopment
                        : DevelopmentStore.shareUsersByDev[dev.id]
                    }
                  >
                    <div
                      onClick={
                        LoginStore.isTrialUser()
                          ? () => DevelopmentStore.showTrialMessageError()
                          : this.handleOpenShareDevelopment(dev)
                      }
                      style={{ cursor: "pointer", marginTop: "10px" }}
                    >
                      <Group
                        style={{
                          fontSize: 14,
                          position: "relative",
                          top: 3,
                          marginRight: "5px",
                          color: "#BABABA",
                        }}
                      />
                      {this.userList(dev)}
                    </div>
                  </Tooltip>
                ) : (
                  <div style={{ marginTop: "8px" }}>
                    <Group
                      style={{
                        fontSize: 14,
                        position: "relative",
                        top: 3,
                        marginRight: "5px",
                        color: "#BABABA",
                      }}
                    />
                    {i18n.developments.developmentSharedWithMe}
                  </div>
                )}
              </Typography>
            }
            actionIcon={
              <div
                style={
                  dev.data.address
                    ? { marginTop: "20px" }
                    : { marginTop: "-25px" }
                }
              >
                {(dev.data as any).favorite ? (
                  <StarChecked
                    fontSize="small"
                    cursor="pointer"
                    className={css(styles.starIconChecked)}
                    onClick={
                      isExpired ? () => false : this.handleUnsetFavorite(dev.id)
                    }
                    {...(this.state[`disabled_${dev.id}`] && {
                      classes: { root: css(styles.disabledChecked) },
                    })}
                  />
                ) : (
                  <StarIcon
                    fontSize="small"
                    cursor="pointer"
                    className={css(styles.starIcon)}
                    onClick={
                      isExpired ? () => false : this.handleSetFavorite(dev.id)
                    }
                    style={{ opacity: open ? 1 : 0 }}
                    {...(this.state[`disabled_${dev.id}`] && {
                      classes: { root: css(styles.disabled) },
                    })}
                  />
                )}
              </div>
            }
          />
        </GridListTile>

        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.open}
          message={
            <span id="message-id">{i18n.developments.loadingUpdateWbs}</span>
          }
          onClose={this.handleCloseSnack}
          autoHideDuration={6000}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={this.handleCloseSnack}
            >
              <Close />
            </IconButton>,
          ]}
        />
      </React.Fragment>
    );
  }
}

export default CardGrid;



// WEBPACK FOOTER //
// ./src/modules/development/components/layouts/CardGrid.tsx